import axios from "axios";
import { toast } from "react-hot-toast";

const getBaseUrl = () => {
  if (
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
  ) {
    return "http://localhost:8000";
  }
  if (typeof process !== "undefined" && process?.env) {
    return process.env.VITE_API_URL || process.env.BUN_PUBLIC_API_URL || undefined;
  }
  return undefined;
};

const BASE_URL = getBaseUrl();

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (typeof window !== "undefined") {
      const token = localStorage.getItem("token");
      if (token && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => {
    if (
      (error.response?.status === 401 &&
        error.response?.data?.message === "Access denied") ||
      (error.response?.status === 500 &&
        error.response?.data?.message === "Internal server error")
    ) {
      if (typeof window !== "undefined") {
        localStorage.clear();
        window.location.href = "/login";
      }
    }
    if (!error.response) {
      return Promise.reject(new Error("Network Error: Is the backend server running?"));
    }
    return error.response;
  },
);

export const apiConnector = async ({
  method,
  url,
  bodyData,
  params,
  headers,
}) => {
  const res = await axiosInstance({
    method: method ? `${method}` : null,
    url: url ? url : null,
    data: bodyData ? bodyData : null,
    headers: headers ? headers : null,
    params: params ? params : null,
  });

  return res;
};
